import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'lib-control-field-error-message',
  templateUrl: './control-field-error-message.component.html',
  styleUrls: ['./control-field-error-message.component.scss']
})
export class ControlFieldErrorMessageComponent implements OnInit {
  @Input() controlName!: string;
  @Input() control!: FormControl;

  constructor(private translateService: TranslateService) { }

  ngOnInit(): void {
  }

  get errorMessage(): string {
    return !this.controlName
      ? this.translateService.instant('common.requiredField')
      : this.translateService.instant('common.requiredFieldNamed', { name: this.controlName });
  }

}
